import React, { useState } from 'react';
import '../style.css';

const Hero = ({ onSearch }) => {
  const [query, setQuery] = useState('');

  const handleSearch = () => {
    if (query.trim()) {
      onSearch(query); // Pass query up to parent
    }
  };

  const handleKeyPress = (e) => {
    if (e.key === 'Enter') {
      handleSearch();
    }
  };

  return (
    <header className="hero">
      <h1>QuickFit</h1>
      <p>
        Coming soon! Your go-to AI-powered shopping experience. Order from multiple retailers with same-day delivery, easy exchanges, and hassle-free returns.
      </p>
      <div className="search-bar">
        <input
          type="text"
          placeholder="Search for items or styles"
          value={query}
          onChange={(e) => setQuery(e.target.value)}
          onKeyPress={handleKeyPress}
        />
        <button className="cta-button" onClick={handleSearch}>
          Learn More
        </button>
      </div>
    </header>
  );
};

export default Hero;
